export const API_ADMIN_GET_ALL_QUESTIONLIBRARY = "API_ADMIN_GET_ALL_QUESTIONLIBRARY";
export const API_ADMIN_GET_ALL_QUESTIONLIBRARY_SUCCESS = "API_ADMIN_GET_ALL_QUESTIONLIBRARY_SUCCESS";
export const API_ADMIN_GET_ALL_QUESTIONLIBRARY_FAIL = "API_ADMIN_GET_ALL_QUESTIONLIBRARY_FAIL";

export const API_ADMIN_GET_QUESTIONLIBRARY = "API_ADMIN_GET_QUESTIONLIBRARY";
export const API_ADMIN_GET_QUESTIONLIBRARY_SUCCESS = "API_ADMIN_GET_QUESTIONLIBRARY_SUCCESS";
export const API_ADMIN_GET_QUESTIONLIBRARY_FAIL = "API_ADMIN_GET_QUESTIONLIBRARY_FAIL";

export const API_ADMIN_POST_QUESTIONLIBRARY = "API_ADMIN_POST_QUESTIONLIBRARY";
export const API_ADMIN_POST_QUESTIONLIBRARY_SUCCESS = "API_ADMIN_POST_QUESTIONLIBRARY_SUCCESS";
export const API_ADMIN_POST_QUESTIONLIBRARY_FAIL = "API_ADMIN_POST_QUESTIONLIBRARY_FAIL";

export const API_ADMIN_PATCH_QUESTIONLIBRARY = "API_ADMIN_PATCH_QUESTIONLIBRARY";
export const API_ADMIN_PATCH_QUESTIONLIBRARY_SUCCESS = "API_ADMIN_PATCH_QUESTIONLIBRARY_SUCCESS";
export const API_ADMIN_PATCH_QUESTIONLIBRARY_FAIL = "API_ADMIN_PATCH_QUESTIONLIBRARY_FAIL";

export const API_ADMIN_DELETE_QUESTIONLIBRARY = "API_ADMIN_DELETE_QUESTIONLIBRARY";
export const API_ADMIN_DELETE_QUESTIONLIBRARY_SUCCESS = "API_ADMIN_DELETE_QUESTIONLIBRARY_SUCCESS";
export const API_ADMIN_DELETE_QUESTIONLIBRARY_FAIL = "API_ADMIN_DELETE_QUESTIONLIBRARY_FAIL";

export const ADMIN_INIT_NEW_QUESTIONLIBRARY = "ADMIN_INIT_NEW_QUESTIONLIBRARY";
export const ADMIN_RESET_FOCUS_QUESTIONLIBRARY = "ADMIN_RESET_QUESTIONLIBRARY";
